const indexItems = [
  { tag: '电影', title: '动作冒险', count: '386部', color: 'primary' as const },
  { tag: '电影', title: '喜剧搞笑', count: '274部', color: 'accent' as const },
  { tag: '电影', title: '科幻奇幻', count: '198部', color: 'secondary' as const },
  { tag: '电视剧', title: '国产剧集', count: '512部', color: 'primary' as const },
  { tag: '电视剧', title: '海外剧集', count: '346部', color: 'accent' as const },
  { tag: '综艺', title: '音乐竞演', count: '89档', color: 'secondary' as const },
  { tag: '动漫', title: '国漫精选', count: '156部', color: 'primary' as const },
  { tag: '纪录片', title: '自然探索', count: '203部', color: 'accent' as const },
  { tag: '专题', title: '经典怀旧', count: '428部', color: 'secondary' as const },
];

const colorStyles = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', icon: 'text-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', icon: 'text-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', icon: 'text-secondary-500' },
};

const iconMap: Record<string, string> = {
  '动作冒险': 'ri-sword-line',
  '喜剧搞笑': 'ri-emotion-laugh-line',
  '科幻奇幻': 'ri-rocket-line',
  '国产剧集': 'ri-tv-line',
  '海外剧集': 'ri-global-line',
  '音乐竞演': 'ri-music-line',
  '国漫精选': 'ri-paint-brush-line',
  '自然探索': 'ri-leaf-line',
  '经典怀旧': 'ri-film-line',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            影视索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            按类别浏览所有影视内容，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => {
            const cs = colorStyles[item.color];
            const icon = iconMap[item.title] || 'ri-movie-line';
            return (
              <div
                key={item.title}
                className="group flex items-center gap-4 bg-background-100 hover:bg-background-200/80 rounded-xl p-4 md:p-5 cursor-pointer border border-background-200/60 transition-all duration-200"
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${cs.bg}`}>
                  <i className={`${icon} text-lg ${cs.icon}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded whitespace-nowrap ${cs.bg} ${cs.text}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-shrink-0 text-xs text-foreground-400 font-medium whitespace-nowrap">
                  {item.count}
                </div>
                <div className="flex-shrink-0 text-foreground-200 group-hover:text-primary-400 transition-colors">
                  <i className="ri-arrow-right-s-line"></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}